import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ e('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M20 0C12.07 0 5.22 4.614 1.985 11.304h36.03C34.782 4.614 27.93 0 20 0Z"></path><path fill="#0052B4" d="M20 40c7.93 0 14.78-4.614 18.016-11.304H1.985C5.22 35.386 12.07 40 20 40Z"></path><path fill="#6DA544" d="m24.92 14.211-1.845 1.845a4.348 4.348 0 1 1-6.149 0l-1.844-1.845a6.956 6.956 0 1 0 9.838 0Z"></path><path fill="#FFDA44" d="m20 16.522.648 1.993h2.095l-1.695 1.231.648 1.993L20 20.507l-1.695 1.232.648-1.993-1.696-1.231h2.096L20 16.522Z"></path>', 5), o = [
  h
];
function c(p, n) {
  return t(), a("svg", l, [...o]);
}
const r = { render: c };
export {
  r as default,
  c as render
};
